/**
 * Copyright © 2025 Delicious AI, LLC
 *
 * @author Bryan Sheranian <bryan.sheranian@deliciousai.com>
 */

import { gql } from '@apollo/client'
import { GROUP_FRAGMENT } from '../fragments/GroupFragment'

export const GET_GROUPS = gql`
  query GetGroups {
    groups {
      ...Group
    }
  }
  ${GROUP_FRAGMENT}
`
